const floorList = [
    {
        img: '2',
        text1: 'ABOUT',
        text2: 'JIANZHEN',
        text3: '见微知真 甄酒值鉴',
        text4: '集成了北京茅台文化研究会10余年研究鉴藏经验，联合行业领先的技术伙伴，让老酒鉴定数字化、标准化、智能化成为可能。'
    },
    {
        img: '3_1',
        text1: 'ABOUT',
        text2: 'JIANZHEN',
        text3: '见甄“科技鉴藏”赋能',
        text3_1: '茅友公社 X 京东 战略合作',
        text4: '在茅友公社整个交易体系中，见甄系统通过鉴别真伪和区块链防伪溯源，让一瓶老酒实现“二次出厂”，为老酒的流通交易保驾护航。'
    },
]

const tabs = [
    {
        img: '4',
        text1: '一瓶/箱一码 正品可溯',
        text2: '防伪溯源系统',
        text3: 'RFID防伪芯片：与贵州茅台酒所用芯片同源，不可制。<br/>联合京东数科智臻链，引入区块链技术：从原产地到消费者，记录商品各个流转环节的重要数据，保障用户权益。'
    },
    {
        img: '5',
        text1: '人工智能 智慧于「芯」',
        text2: '见甄AI鉴酒盒子',
        text3: '联合阿里达摩院与蜂鸟科技，将人工智能算法与北京茅台文化研究会10余年老酒鉴藏研究结合。<br/>普通人2小时操作培训 + 见甄AI鉴酒盒子 = 从业10年以上的专业鉴酒师。'
    },
    {
        img: '6_1',
        text1: '随时随地鉴酒',
        text2: '见甄小程序',
        text3: '根据年份分级鉴定，用户仅需根据示意上传指定的酒品细节图，见甄鉴酒师团队将依据照片的细节特征进行鉴别，极速反馈鉴别结果。'
    },
    {
        img: '7',
        text1: '洞察需求整合行业领先技术',
        text2: 'WMS+',
        text3: '基于见甄体系搭建一体化管理系统，保留传统仓配功能，<br/> 同时扩展茅台酒品的初鉴、复鉴、溯源业务。<br/> 保证鉴采流程安全、可靠、可追溯。'
    },
    {
        img: '8_1',
        text1: '新零售智慧管理系统',
        text2: '门店管家',
        text3: '针对新零售环境下的不同应用场景，<br/>为线下门店打造专属管理工具。<br/>将获客与服务结合，实现智能营销。'
    }
]

const businessList = [
    {
        img: '10',
        text1: 'Intelligent',
        text2: 'Technology',
        text3: '线下智慧鉴定一站式服务',
        text3_1: '见甄鉴定中心',
        text4_min: '依托见甄鉴别溯源Saas系统技术，整合见甄专业鉴酒师资源，打造线下智慧鉴酒一站式服务。',
        text5_min: ' 鉴别溯源全流程解决方案，分层鉴别、溯源激活、溯源贴码全流程操作。'
    },
    {
        img: '9_1',
        text1: 'Intelligent',
        text2: 'Technology',
        text3: '智能技术拓展多领域业务',
        text4: '打造服务工具',
        text5: '为茅友公社新零售业务赋能'
    },
]

const events = [
    {
        img: 'banner4',
        text1: '见甄AI鉴酒盒子首次亮相<br/>阿里云开发者大会',
        text2: '见甄AI鉴酒盒子1.0版首秀测试，成为今年阿里云开发者大会上最令人印象深刻的人工<br/>智能产品之一。',
        url: 'https://www.163.com/news/article/GBATOERP00019OH3.html'
    },
    {
        img: 'banner1',
        text1: '厦门站落幕，茅友公社携手京东酒世界推动老酒见甄服务',
        text2: '4月28日，随着现场最后一名酒友满意的与鉴定师道谢，茅友公社“老酒见甄(回收)全国行”活动第二站——厦门站活动也圆满的落下帷幕。作为京东酒世界禾祥西店开业典礼中的重要环节，本次活动现场举办了茅友公社与合作店铺的合作授牌仪式，同时来自茅友公社·见甄鉴定中心的鉴酒师现场讲解并进行老酒鉴定，为广大厦门茅台酒友提供了急需的鉴定、估价、回收等服务。',
        url: 'https://new.qq.com/rain/a/20210429A08OPD00'
    },
    {
        img: 'banner2',
        text1: '十年磨一剑，茅友公社携手京东打造老酒交易新模式',
        text2: '2021年1月20日，茅友公社作为专注茅台老酒鉴藏交易的新零售平台，与京东达成战略合作，宣布成立以科技鉴藏为基础的老酒交易平台——搜茅网。双方将围绕老酒鉴藏交易从品牌共建、渠道布局、科技鉴别、防伪溯源、数字化交易与文化传播等多方面深度协同。',
        url: 'https://finance.ifeng.com/c/83C2Gf27C1U'
    },
    {
        img: 'banner3',
        text1: '千呼万唤始出来，茅友公社正式上线茅台老酒“见甄系统”',
        text2: '9月26日，专注茅台老酒鉴藏交易的茅友公社平台举办了新零售战略发布会，并正式上线“见甄系统”。它有望解决茅台老酒交易痛点，在老酒行业内创建“AI+大数据”的全新应用场景，助力行业健康有序发展。',
        url: 'http://www.cb.com.cn/index/show/gd_m/cv/cv1361104301490'
    }
]

export {
    floorList,
    tabs,
    businessList,
    events
}